import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrivacyPolicyComponent } from './pages/privacy-policy.component';

@NgModule({
    declarations: [PrivacyPolicyComponent],
    imports: [CommonModule],
})
export class PrivacyPolicyModule {}
